import { HOVER_POSITION } from '@instructure/quiz-common';
export function newHoverPosition(positionObj) {
  return {
    type: HOVER_POSITION,
    payload: positionObj
  };
}